export default "__VITE_ASSET__BdZ3K8wH__"